__turbopack_context__.v({
  "icon": "PurchaseGuarantee-module-scss-module__6yD98q__icon",
  "list": "PurchaseGuarantee-module-scss-module__6yD98q__list",
  "listItem": "PurchaseGuarantee-module-scss-module__6yD98q__listItem",
  "purchaseGuarantee": "PurchaseGuarantee-module-scss-module__6yD98q__purchaseGuarantee",
  "title": "PurchaseGuarantee-module-scss-module__6yD98q__title",
  "tooltipInline": "PurchaseGuarantee-module-scss-module__6yD98q__tooltipInline",
  "tooltipWrapper": "PurchaseGuarantee-module-scss-module__6yD98q__tooltipWrapper",
});
